import React, { Component } from 'react';
import {
    Container, Row
} from 'reactstrap';
import styles from './refundestimator/landing.module.css';
import classNames from 'classnames';

export class Header extends Component {
	render() {
		return (
            <header className="container-fluid">
                <Container>
                    <Row>
                        <img className="logo" src={require('../assets/images/aig-logo.svg')} alt="AIG" />
                        
                    </Row>
                </Container>
            </header>
		);
	}
}